import {
  Checkbox, mergeStyleSets, Stack, Text,
} from '@fluentui/react';
import React from 'react';
import { isMobile } from 'react-device-detect';
import { Label } from 'reactstrap';
import HelpButton from '../help/HelpButton';
import StackTokens from '../StackTokens';
import TextFieldBuffered from '../TextFieldBuffered';
import Theme from '../Theme';
import Header from './Header';

const componentStylesRaw = {
  textFieldRoot: {
    wrapper: {
      marginTop: 'none !important',
    },
  },
  checkbox: {
    label: {
      margin: '0',
    },
  },
};

const componentStyles = mergeStyleSets({
  callbackHeaders: {
    marginTop: '0 !important',
    selectors: {
      label: {
        padding: 0,
      },
    },
  },
});

export default ({ config, updateConfig }) => {
  const [newHeaderName, setNewHeaderName] = React.useState('');
  const [newHeaderValue, setNewHeaderValue] = React.useState('');

  return (
    <>
      <Checkbox
        label={(
          <>
            <Stack horizontal tokens={StackTokens.spacing5}>
              <Text>Enable callback</Text>
              <HelpButton styles={{ root: { marginLeft: '5px' } }} title="Enable callback">
                <div style={isMobile ? {} : {
                  maxWidth: '45vw',
                }}
                >
                  <Text block>When enabled, inputs and outputs will be sent to the provided URL by POST request using headers you provide.</Text>
                </div>
              </HelpButton>
            </Stack>
          </>
        )}
        checked={config.enabled}
        onChange={() => {
          updateConfig('enabled', !config.enabled);
        }}
        styles={componentStylesRaw.checkbox}
      />

      { config.enabled && (
      <>
        <TextFieldBuffered
          label="Callback URL"
          actualValue={config.url || ''}
          validateValue={(value) => {
            const validatedValue = value.trim();
            if (!validatedValue.startsWith('http://') && !validatedValue.startsWith('https://')) {
              throw new Error('Invalid format');
            }
            return validatedValue;
          }}
          applyValue={async (value) => {
            updateConfig('url', value);
          }}
          styles={componentStylesRaw.textFieldRoot}
        />

        <Label className={Theme.styles.noBottomMargin}>Custom headers</Label>
        <Header
          headerName={newHeaderName}
          headerValue={newHeaderValue}
          onHeaderNameChange={setNewHeaderName}
          onHeaderValueChange={setNewHeaderValue}
          add={(name, value) => {
            if (!name || !value) {
              return;
            }
            const updatedHeaders = config.headers || {};
            updatedHeaders[name] = value;
            updateConfig('headers', updatedHeaders);
            setNewHeaderName('');
            setNewHeaderValue('');
          }}
          className={componentStyles.callbackHeaders}
        />

        <Stack vertical tokens={StackTokens.spacing5}>
          {
            Object.entries((config.headers || {})).map(([headerName, headerValue]) => (
              <Header
                key={headerName}
                headerName={headerName}
                headerValue={headerValue}
                apply={(hName, hValue) => {
                  if (!hName || !hValue) {
                    return;
                  }
                  const updatedHeaders = config.headers || {};
                  updatedHeaders[hName] = hValue;
                  updateConfig('headers', updatedHeaders);
                }}
                remove={(hName) => {
                  const updatedHeaders = config.headers || {};
                  delete updatedHeaders[hName];
                  updateConfig('headers', updatedHeaders);
                }}
              />
            ))
           }
        </Stack>
      </>
      )}
    </>
  );
};
